import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApi, OpalApiResponseDocument } from '../../schema'

type ReadSmartBlocksBFF = OpalApi<'ReadSmartBlocksBFFV1', 200>
type ReadSmartBlockBFFResponse = OpalApiResponseDocument<
  'ReadSmartBlocksBFFV1',
  200
>

export const readSmartBlocks: ReadSmartBlocksBFF = ({
  params,
}: Parameters<ReadSmartBlocksBFF>[0] = {}) => {
  if (!params) {
    throw new Error(
      'readSmartBlocks must be provided with params.path.workspace_id'
    )
  }

  const url = new URL(
    `/asgard-bff/${params.path.workspace_id}/smart_blocks`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get<ReadSmartBlockBFFResponse>(url.toString())
    .then((res) => res.data)
}
